"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _reactStripeJs = require("@stripe/react-stripe-js");

var _reactGoogleRecaptchaV = require("react-google-recaptcha-v3");

var _config = require("../config");

var _PaymentHeader = _interopRequireDefault(require("../components/PaymentHeader/PaymentHeader"));

var _PaymentRequestButton = require("./PaymentRequestButton");

var _Button = _interopRequireDefault(require("./Button"));

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("formPage", _flowRuntime["default"].object()), _flowRuntime["default"].property("submitBtnText", _flowRuntime["default"].string()), _flowRuntime["default"].property("onSuccess", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].string()), _flowRuntime["default"]["return"](_flowRuntime["default"].any())))));

var PaymentForm = function PaymentForm(_arg) {
  var formPage = _arg.formPage,
      onSuccess = _arg.onSuccess,
      submitBtnText = _arg.submitBtnText;
  var stripe = (0, _reactStripeJs.useStripe)();
  var elements = (0, _reactStripeJs.useElements)();

  var _useGoogleReCaptcha = (0, _reactGoogleRecaptchaV.useGoogleReCaptcha)(),
      executeRecaptcha = _useGoogleReCaptcha.executeRecaptcha;

  var formSelector = (0, _reduxForm.formValueSelector)('form');
  var amountValue = (0, _reactRedux.useSelector)(function (state) {
    return formSelector(state, 'donation.amount');
  }, _reactRedux.shallowEqual);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      loadingPaymentSecret = _useState2[0],
      setLoadingPaymentSecret = _useState2[1];

  var _useState3 = (0, _react.useState)('default secret'),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      paymentIntentSecret = _useState4[0],
      setPaymentIntentSecret = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      paymentSecretError = _useState6[0],
      setPaymentSecretError = _useState6[1];

  var _useState7 = (0, _react.useState)(),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      paymentError = _useState8[0],
      setPaymentError = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      cardElementReady = _useState10[0],
      setCardElementReady = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      submitting = _useState12[0],
      setSubmitting = _useState12[1];

  var loadingCardElements = !stripe || !elements || !cardElementReady;

  var getPaymentIntentSecret = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
      var recaptchaToken, response, clientSecret;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (executeRecaptcha) {
                _context.next = 3;
                break;
              }

              // eslint-disable-next-line no-console
              console.log('Execute recaptcha not yet available');
              return _context.abrupt("return");

            case 3:
              setLoadingPaymentSecret(true);
              _context.next = 6;
              return executeRecaptcha('Stripe_Payment_Intent');

            case 6:
              recaptchaToken = _context.sent;
              _context.next = 9;
              return fetch("".concat((0, _config.getApiBaseUrl)(), "/payments/secret?amount=").concat(amountValue, "&recaptchaToken=").concat(recaptchaToken));

            case 9:
              response = _context.sent;

              if (!response.ok) {
                _context.next = 17;
                break;
              }

              _context.next = 13;
              return response.json();

            case 13:
              clientSecret = _context.sent;
              setPaymentIntentSecret(clientSecret);
              _context.next = 18;
              break;

            case 17:
              setPaymentSecretError('Error initiating payment flow, please reload the page and try again.');

            case 18:
              setLoadingPaymentSecret(false);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getPaymentIntentSecret() {
      return _ref.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    getPaymentIntentSecret(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var giftaidValue = (0, _reactRedux.useSelector)(function (state) {
    return formSelector(state, 'donation.giftaid');
  }, _reactRedux.shallowEqual);
  var personalDetails = (0, _reactRedux.useSelector)(function (state) {
    return formSelector(state, 'personalDetails');
  }, _reactRedux.shallowEqual);
  var firstName = personalDetails.firstName,
      lastName = personalDetails.lastName,
      address = personalDetails.address,
      email = personalDetails.email;
  var line1 = address.line1,
      line2 = address.line2,
      postcode = address.postcode,
      town = address.town;
  var cardholderName = "".concat(firstName, " ").concat(lastName);

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(event) {
      var result;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              event.preventDefault();

              if (!loadingCardElements) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              setSubmitting(true);
              _context2.next = 6;
              return stripe.confirmCardPayment(paymentIntentSecret, {
                payment_method: {
                  card: elements.getElement(_reactStripeJs.CardElement),
                  billing_details: {
                    address: {
                      line1: line1,
                      line2: line2,
                      city: town,
                      postal_code: postcode
                    },
                    email: email,
                    name: cardholderName
                  }
                }
              });

            case 6:
              result = _context2.sent;

              if (result.error) {
                setPaymentError(result.error.message);
                setSubmitting(false);
              } else if (result.paymentIntent.status === 'succeeded') {
                setSubmitting(false);
                onSuccess(result.paymentIntent.id);
              }

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var cardElementOptions = {
    style: {
      base: {
        color: '#555',
        fontSize: '16px',
        '::placeholder': {
          color: '#999'
        }
      },
      invalid: {
        color: '#e36060',
        iconColor: '#e36060'
      }
    },
    value: {
      postalCode: postcode
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_PaymentHeader["default"], {
    amountValue: amountValue,
    giftaidValue: giftaidValue,
    formPage: formPage
  }), loadingPaymentSecret && /*#__PURE__*/_react["default"].createElement("div", {
    className: "loader loader--relative"
  }), !loadingPaymentSecret && !paymentSecretError ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_PaymentRequestButton.PaymentRequestButton, {
    amountValue: amountValue,
    onSuccess: onSuccess,
    paymentIntentSecret: paymentIntentSecret,
    setPaymentError: setPaymentError,
    setSubmitting: setSubmitting,
    stripe: stripe
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "payment-method-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("h3", null, /*#__PURE__*/_react["default"].createElement("span", null, "Card Payment")), /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: onSubmit
  }, /*#__PURE__*/_react["default"].createElement("label", {
    style: {
      position: 'relative'
    }
  }, "Card details", loadingCardElements && /*#__PURE__*/_react["default"].createElement("div", {
    className: "loader exsmall"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: paymentError ? 'payment-error' : null
  }, /*#__PURE__*/_react["default"].createElement(_reactStripeJs.CardElement, {
    key: amountValue,
    onChange: function onChange() {
      return setPaymentError(undefined);
    },
    onReady: function onReady() {
      return setCardElementReady(true);
    },
    options: cardElementOptions
  }))), paymentError && /*#__PURE__*/_react["default"].createElement("div", {
    className: "error-message"
  }, paymentError), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    arrow: "right",
    disabled: submitting || loadingCardElements,
    label: submitBtnText,
    level: "primary",
    loading: submitting,
    type: "submit"
  })))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "error-message",
    style: {
      marginTop: '1em'
    }
  }, paymentSecretError));
};

var _default = PaymentForm;
exports["default"] = _default;